import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import ApproachSection from './components/ApproachSection';
import PhilosophySection from './components/PhilosophySection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <main className="min-w-[1024px]">
      <HeroSection />
      <AboutSection />
      <CapabilitiesSection />
      <ApproachSection />
      <PhilosophySection />
      <ContactSection />
    </main>
  );
}